export default "__VITE_ASSET__199b5b1b__"